module.exports = __webpack_public_path__ + "media/images/hexa6-aa09d63aec3871944b84cc8e3aa48aba.png";